// extracted by mini-css-extract-plugin
export default {"bannerImage":"BannerImage_bannerImage__N4hdh","image":"BannerImage_image__dlXs8","fadeIn":"BannerImage_fadeIn__dS9C1"};